import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import RHService from '../../../../../../services/rh-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Terceirizado = () => {
    let { id } = useParams()
    const [nome, setNome] = useState("");
    const [cargo, setCargo] = useState("");
    const [empresa, setEmpresa] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchTerceirizado(id) {
        const response = await RHService.terceirizadosEdit(id);
        setNome(response.data["nome"]);
        setEmpresa(response.data["empresa"]);
        setCargo(response.data["cargo"]);
    }

    useEffect(() => {
        fetchTerceirizado(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await RHService.editarTerceirizados(id, {
                nome: nome,
                empresa: empresa,
                cargo: cargo,
            })
            if (local.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Funcionário"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="cargo">
                                <FloatingLabel
                                    label="Cargo Ocupado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cargo"
                                        value={cargo}
                                        onChange={e => setCargo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="empresa">
                                <FloatingLabel
                                    label="Empresa Terceirizada"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="empresa"
                                        value={empresa}
                                        onChange={e => setEmpresa(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/rh/terceirizado/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Funcionário Terceirizado editado com sucesso!</Alert>
                <Navigate to={'/restrito/rh/terceirizado/listar'} />
            </Fragment>
        )
    }
}

export default Terceirizado;